const SESSION_KEY = "motomco_analytics_session";
const LAST_ACTIVITY_KEY = "motomco_analytics_last_activity";

const createId = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `sess_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
};

export const getSessionId = (idleMs = 30 * 60 * 1000) => {
  try {
    const now = Date.now();
    const lastActivity = Number(sessionStorage.getItem(LAST_ACTIVITY_KEY) || 0);
    let sessionId = sessionStorage.getItem(SESSION_KEY);

    if (!sessionId || (lastActivity && now - lastActivity > idleMs)) {
      sessionId = createId();
      sessionStorage.setItem(SESSION_KEY, sessionId);
    }

    sessionStorage.setItem(LAST_ACTIVITY_KEY, String(now));
    return sessionId;
  } catch {
    return createId();
  }
};

export const touchSession = () => {
  try {
    sessionStorage.setItem(LAST_ACTIVITY_KEY, String(Date.now()));
  } catch {
    /* ignore */
  }
};
